import { Component, Prop } from "@stencil/core";

/**
 * The LicenseProvider component is responsible for supplying the license key
 * to the Trumpf UI library. It should be included once in your application's root.
 * The license key itself is checked and validated globally (see ux.ui.core.ts).
 */
@Component({
    tag: "ux-license-provider"
})
export class LicenseProvider {
    /**
     * The license key to be used for the application. License keys can be obtained
     * from the Trumpf UiLib team for free. This property is read-only and reflected
     * as an attribute on the custom element.
     */
    @Prop({ reflect: true }) readonly licenseKey: string;
}
